import { BarSkeleton } from "./bar";
import { LineSkeleton } from "./line";
import { MetricSkeleton } from "./metric";
const Skeletons = (id) => {
    switch (id) {
        case "metric":
            return MetricSkeleton;
        case "bar":
            return BarSkeleton;
        case "line":
            return LineSkeleton;
        case "area":
            return LineSkeleton;
        case "pie":
            return BarSkeleton;
        case "matrix":
            return BarSkeleton;
        case "table":
            return BarSkeleton;
        case "map":
            return BarSkeleton;
        case "sankey":
            return BarSkeleton;
        default:
            return BarSkeleton;
    }
};
export default Skeletons;
//# sourceMappingURL=index.js.map